import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { User } from 'app/model/user.model';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.css']
})
export class RegisterPageComponent implements OnInit {

  model = new User();
  error: string;

  constructor(
    private router: Router,
    private authService: AuthService) { }

  ngOnInit() {
  }

  getIsHK(): boolean {
    return isHK;
  }

  clearError() {
    this.error = '';
  }

  register() {
    const ___this = this;
    this.authService.registerUser(this.model.email, this.model.password)
      .then((user) => {
        ___this.authService.superUser = true;

        ___this.router.navigate(['/main']);
      }).catch(function (error) {
        // Handle Errors here.
        ___this.model.email = '';
        ___this.model.password = '';
        ___this.authService.superUser = false;
        const errorCode = error.code;
        const errorMessage = error.message;
        ___this.error = errorMessage;
        console.log(errorMessage);
      });
  }

  onSubmit() {
    this.register();
  }
  isSU() {
    return this.authService.superUser;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/register-page/register-page.component.ts